import { Bell, Search, HelpCircle } from 'lucide-react';
import { Input } from '../ui/input';

export const Header = ({ title, subtitle }) => {
  return (
    <header className="h-16 bg-[#0D5B69] flex items-center justify-between px-6" data-testid="header">
      {/* Title Section */}
      <div>
        <h1 className="font-heading font-bold text-white text-xl">{title}</h1>
        {subtitle && <p className="text-cyan-100/80 text-sm">{subtitle}</p>}
      </div>

      {/* Actions Section */}
      <div className="flex items-center gap-4">
        {/* Search */}
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
          <Input
            type="text"
            placeholder="Search incidents, customers..."
            className="pl-10 w-64 bg-white/10 border-white/20 text-white placeholder:text-white/50 focus:bg-white/20"
            data-testid="global-search"
          />
        </div>

        {/* Help */}
        <button className="p-2 hover:bg-white/10 rounded-md transition-colors" data-testid="help-btn">
          <HelpCircle className="w-5 h-5 text-white/80" />
        </button>

        {/* Notifications */}
        <button className="p-2 hover:bg-white/10 rounded-md transition-colors relative" data-testid="notifications-btn">
          <Bell className="w-5 h-5 text-white/80" />
          <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
        </button>
      </div>
    </header>
  );
};
